import './tickets.less';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cn from 'classname';
import { Link } from 'react-router';
import Search from '../../shared/search/main';

import get from 'lodash/get';
import find from 'lodash/find';
import flatten from 'lodash/flatten';
import last from 'lodash/last';

import LinkToThread from '../../shared/link';

const propTypes = {
	ticketsList: PropTypes.object,
	data: PropTypes.object,
	switchToTicket: PropTypes.func,
	intl: PropTypes.func,
	search: PropTypes.func,
	can: PropTypes.func
};

class Requests extends React.Component {
	componentDidMount() {
		const { data: { id } } = this.props;
		const $wrap = this.refs['wrap'];
		const $activeTicket = this.refs[`ticket_${id}`];
		if ($activeTicket) {
			$wrap.scrollTop = $activeTicket.offsetTop - $activeTicket.offsetHeight;
		}
	}

	render() {
		const { ticketsList, intl } = this.props;

		return (
			<div className="ext-thread-container">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Link to="external-tickets/" className="link">
							{intl('Return to list of threads')}
						</Link>
					</div>
				</div>

				<div className="ext-support__tickets" ref="wrap">
					<span className="support__tickets--shadow" />
					<div className="support__tickets-search">
						<Search
							form="threadsItemSearchForm"
							action={this.props.search}
						/>
					</div>

					{ ticketsList.type === 'group' && ticketsList.rows.length && (
						getGroupedTicket(ticketsList.rows, this.props)
					)}

					{ ticketsList.type === 'list' && (
						ticketsList.rows.map(row => ticketItem(row, this.props))
					)}

				</div>
			</div>
		);
	}
}

const getRowStyle = (statusesList, row) => {
	let style = [];
	let rowStatus = row.status;
	style.push(get(find(statusesList, status => status.id === rowStatus), 'id'));

	let isWithoutAnswer = !last(row.posts).admin_id;

	let isLongWithoutAnswer = isWithoutAnswer &&
		Math.abs(moment.duration(moment(row.updated_at).diff()).asHours()) > 1;

	if (isLongWithoutAnswer) {
		style.push('long-without-answer');
	} else if (isWithoutAnswer) {
		style.push('without-answer');
	}

	return style.join(' ');
};

// functions
const ticketItem = (row, props, className = '') => (
	<div className="ext-support__tickets-group" key={row.date}>
		<p className="date">
			{moment(row.date).format('DD.MM.YYYY')}
		</p>
		{row.tickets.map(ticket => {
			const maxThemeLen = 45;
			const theme = ticket.posts[0].text && ticket.posts[0].text.length > maxThemeLen
				? ticket.posts[0].text.substr(0, maxThemeLen) + '...'
				: ticket.posts[0].text;

			return (
				<LinkToThread
					to={`external-tickets/${ticket.id}`}
					requestQueryString={window.location.search.slice(1)}
					ref={`ticket_${ticket.id}`}
					className={cn({
						ticket: true,
						selected: props.data.id === ticket.id,
						[className]: className.length,
						[`${getRowStyle(props.threadStatusesList, ticket)}`]: true
					})}
					key={ticket.id}>
					<div className="ticket__header clearfix">
						<p className="name">{ticket.name}</p>
						<p className="email">{ticket.email}</p>
						<p className="time">
							{moment(ticket.updated_at).format('HH:mm')}
						</p>

					</div>
					<p className="theme">
						{theme}
						{!ticket.viewed_at &&
						<span className="unread" />}
					</p>
				</LinkToThread>
			);
		})}
	</div>
);

ticketItem.propTypes = {
	threadStatusesList: PropTypes.array,
	can: PropTypes.func
};

const getGroupedTicket = (rows, props) => {
	const res = [];

	rows.forEach((row, i) => {
		row.data.length && res.push(
			<div key={i} className={`ext-group--${row.className}`}>
				<span className="title font-roboto-bold">{props.intl(row.name)}</span>
			</div>
		);

		res.push(
			flatten(
				row.data.map((entity, i) => ticketItem(entity, props, `row--${row.className}`))
			)
		);
	});

	return res;
};

Requests.propTypes = propTypes;
export default Requests;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/tickets.js